module.exports = __webpack_public_path__ + "static/media/6TheMuseumOfTheWorld.4bcbf5e4.JPG";